import { FormDialog } from "../../components/FormDialog/FormDialog";

const EnvisionDocumentDialog = ({ formId, readOnly, saveEnvisionDocumentData, envisionDocumentSchema, formData, handleFormChange }) => {

    return (
        <FormDialog formId={formId}
            formData={formData}
            schema={envisionDocumentSchema}
            handleFormChange={handleFormChange}
            readOnly={readOnly}
            saveFormData={saveEnvisionDocumentData}
        />
    );

}

export default EnvisionDocumentDialog;
